import { Navigate } from "react-router-dom";
import { useUserData } from "../data/providers/UserDataProvider";

export default function RoleSwitch() {
  const userData = useUserData();
  if (userData.loading) return null;
  const role = userData?.data?.role ?? "USER";
  const landingByRole: Record<string, string> = {
    ADM: "all-applications",
    USER: "applications",
  };

  const to = landingByRole[role] ?? "applications";
  return <Navigate to={`/dashboard/${to}`} replace />;
}
